var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "#D2F34C",
    stroke: "#D2F34C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3947 43.7151C32.6312 43.7151 26 44.9391 26 49.8351C26 54.7329 32.5898 56.0002 40.3947 56.0002C48.1581 56.0002 54.7893 54.7779 54.7893 49.8801C54.7893 44.9823 48.2013 43.7151 40.3947 43.7151Z",
    fill: "#244034"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40.3948 39.0513C45.6832 39.0513 49.9204 34.8123 49.9204 29.5256C49.9204 24.239 45.6832 20 40.3948 20C35.1082 20 30.8691 24.239 30.8691 29.5256C30.8691 34.8123 35.1082 39.0513 40.3948 39.0513Z",
    fill: "#244034"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateIcon);
export default __webpack_public_path__ + "static/media/CreateIcon.3aa778fbe3c857ed9858bdfa4d6d813e.svg";
export { ForwardRef as ReactComponent };